import React from 'react';

import { useGetFeatureAccess } from 'v2/hooks/useGetFeatureAccess';

import Wallet from './component';

function WalletWithHook() {
  const { data: featureAccessData } = useGetFeatureAccess();

  return <Wallet anticipationStatus={featureAccessData?.anticipation} />;
}

export default WalletWithHook;
